import React, { useEffect, useState } from "react";
import { LoadingBoxFillComponent } from "../../../components/state/Loading";
import { useServiceContext } from "../../../../contexts/ServiceContext";
import { TemplateProfile } from "../../../../core/entities/templateProfile";
import { TemplateTypeDisplay } from "../../../../core/entities/templateTypeDisplay";
import { useTemplateOverviewViewModel } from "./vmHooks/useTemplateOverviewViewModel";
import { TemplateOverviewComponent } from "./TemplateOverview.Component";
import { ReplacementField } from "../../../../core/entities/replacementField";
import { ErrorPageScreen } from "../../public/ErrorPage/ErrorPage.Screen";

export function TemplateOverviewScreen() {
    const [error, setError] = useState<any>();
    const [templateTypes, setTemplateTypes] = useState<TemplateTypeDisplay[]>();
    const [replacementFields, setReplacementFields] =
        useState<ReplacementField[]>();
    const [templateProfiles, setTemplateProfiles] =
        useState<TemplateProfile[]>();
    const {
        templateService: {
            getAllTemplateProfiles,
            getTypes,
            getReplacementFields
        }
    } = useServiceContext();

    useEffect(() => {
        if (!templateTypes) {
            getTypes().then(setTemplateTypes).catch(setError);
        }
    }, [getTypes, templateTypes]);

    useEffect(() => {
        if (!replacementFields) {
            getReplacementFields().then(setReplacementFields).catch(setError);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [replacementFields]);

    useEffect(() => {
        if (!templateProfiles) {
            getAllTemplateProfiles()
                .then((x) => setTemplateProfiles(x))
                .catch(setError);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateProfiles]);

    function replaceProfile(profile: TemplateProfile) {
        if (!templateProfiles) {
            console.warn("Unreachable Branch Reached");
            return;
        }
        setTemplateProfiles((tpState) => {
            const index = tpState!.findIndex((tp) => tp.type === profile.type);
            tpState!.splice(index, 1, profile);
            return tpState;
        });
    }

    const isLoading = !(templateTypes && templateProfiles && replacementFields);
    return isLoading && !error ? (
        <LoadingBoxFillComponent />
    ) : error ? (
        <ErrorPageScreen error={error} />
    ) : (
        <TemplateOverviewLoaded
            templateProfiles={templateProfiles!}
            templateTypes={templateTypes!}
            replaceProfile={replaceProfile}
            replacementFields={replacementFields!}
        />
    );
}

interface Props {
    templateTypes: TemplateTypeDisplay[];
    templateProfiles: TemplateProfile[];
    replaceProfile: (profile: TemplateProfile) => void;
    replacementFields: ReplacementField[];
}

export function TemplateOverviewLoaded({
    templateTypes,
    templateProfiles,
    replaceProfile,
    replacementFields
}: Props) {
    const vm = useTemplateOverviewViewModel(
        templateTypes,
        templateProfiles,
        replaceProfile,
        replacementFields
    );

    return <TemplateOverviewComponent {...vm} />;
}
